import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Crown, Zap } from "lucide-react";

// Shows daily generation usage + an upgrade promo for non-Pro users.
// Pro users (ad-free) see nothing. Re-fetches when `version` changes.
export const UpgradeBanner = ({ version = 0 }) => {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!user || user.is_pro) return;
    api.get("/subscription/status").then(({ data }) => setStatus(data)).catch(() => {});
  }, [user, version]);

  if (!user || user.is_pro) return null;

  const used = status?.generations_today ?? 0;
  const limit = status?.generations_limit ?? 3;
  const remaining = Math.max(0, limit - used);

  return (
    <div data-testid="upgrade-banner" className="mb-6 flex flex-col gap-3 border border-primary/30 bg-gradient-to-r from-primary/10 to-transparent p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <Zap className="h-5 w-5 text-primary" />
        <p className="text-sm text-foreground/80">
          <span className="font-bold text-primary">{remaining}</span> of {limit} free generations left today.{" "}
          <span className="text-foreground/50">Go Pro for unlimited.</span>
        </p>
      </div>
      <Link to="/pricing" data-testid="banner-upgrade-btn" className="inline-flex items-center justify-center gap-2 border border-primary bg-primary px-4 py-2 text-xs font-bold uppercase tracking-widest text-primary-foreground transition-colors hover:bg-primary/90">
        <Crown className="h-4 w-4" /> Upgrade to Pro
      </Link>
    </div>
  );
};

export default UpgradeBanner;
